module.exports = __webpack_public_path__ + "assets/img/btn-info-9d76c368.png";